import { Form as AntForm, FormProps as AntFormProps } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

export const Form = observer(({ children, form, ...props }: AntFormProps) => {
    const [innerForm] = AntForm.useForm();

    const targetForm = useMemo(() => {
        return form || innerForm;
    }, [form]);

    return (
        <AntForm form={targetForm} {...props}>
            {children}
        </AntForm>
    );
});
